var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundedCheck = function SvgRoundedCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1.25C4.27 1.25 1.25 4.27 1.25 8S4.27 14.75 8 14.75s6.75-3.02 6.75-6.75S11.73 1.25 8 1.25m3.72 5.08-5.18 5.18L4.1 9.07a.85.85 0 0 1 0-1.2c.33-.33.87-.33 1.2 0l1.24 1.24 3.98-3.98c.33-.33.87-.33 1.2 0s.33.87 0 1.2"
  })));
};
export default SvgRoundedCheck;